<table>
	<tr>
		@for (datum of data; track datum) {
			<td [class]="dataType">
				{{ getFormattedValue(datum) }}
			</td>
		}
	</tr>
</table>
